import React, {Component} from 'react';

class SkeletonList extends Component {
  render() {
    const { limit, layout, grid, imageSize, type } = this.props;

    let objects = [];
    for (let i = 0; i < limit; i++) {
      objects.push(
        <div key={"skeleton-" + i} className={`skeleton-grid skeleton-item-${i} ${grid || 'col-6 col-lg-3'}`}>
          <div className={`skeleton-container`}>
            <div className={'image'} />
            {layout === "full" && <div className={'content'}><div className={'title'} /></div>}
          </div>
        </div>
      );
    }

    return (
      <div className={'row vertical-gutters skeleton-wrapper layout-' + layout + " " + (type ? type : '') + ' ' + (imageSize ? imageSize : '')}>
        {objects}
      </div>
    );
  }
}

export default SkeletonList;